import { createTheme, ThemeOptions } from '@mui/material';
import ApercuAktivBlack from '~/Assets/Fonts/ApercuAktiv-Black.woff2';
import ApercuAktivBold from '~/Assets/Fonts/ApercuAktiv-Bold.woff2';
import ApercuAktivExtraLight from '~/Assets/Fonts/ApercuAktiv-ExtraLight.woff2';
import ApercuAktivLight from '~/Assets/Fonts/ApercuAktiv-Light.woff2';
import ApercuAktivMedium from '~/Assets/Fonts/ApercuAktiv-Medium.woff2';
import ApercuAktivRegular from '~/Assets/Fonts/ApercuAktiv-Regular.woff2';
import ApercuAktivThin from '~/Assets/Fonts/ApercuAktiv-Thin.woff2';
import { CHARCOAL_GREY, PRIMARY_BLUE, NOTE_RED, WHITE } from '../Constants/Colors.constants';
import { TRANSITION_MATERIAL } from '../Constants/CSS.constants';

export const NeoBaseTheme: ThemeOptions = {
  breakpoints: {
    values: {
      xs: 0,
      sm: 875,
      md: 1100,
      lg: 1440,
      xl: 1920,
    },
  },
  typography: {
    fontFamily: 'Apercu, sans-serif',
    button: {
      fontWeight: 700,
      fontSize: 16,
      fontFamily: 'Apercu, sans-serif',
    },
  },
  palette: {
    primary: {
      main: PRIMARY_BLUE,
    },
    secondary: {
      main: WHITE,
    },
    error: {
      main: NOTE_RED,
    },
  },
  components: {
    //@ts-ignore
    MuiPickerStaticWrapper: {
      styleOverrides: {
        root: ({ theme }: any) => ({
          [theme.breakpoints.down('md')]: {
            '&  > div > div': {
              display: 'flex',
              flexDirection: 'column',
            },
          },
        }),
      },
    },
    MuiPickersDay: {
      styleOverrides: {
        root: {
          width: 32,
          height: 32,
        },
      },
    },
    MuiTypography: {
      styleOverrides: {
        root: {
          color: CHARCOAL_GREY,
        },
        h4: {
          fontSize: 16,
          fontWeight: 'bold',
          lineHeight: '20px',
        },
        h6: {
          fontWeight: 'bold',
          fontSize: 16,
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 0,
          textTransform: 'none',
          transition: `background-color ${TRANSITION_MATERIAL},box-shadow ${TRANSITION_MATERIAL},border ${TRANSITION_MATERIAL},color ${TRANSITION_MATERIAL}`,
        },
        contained: {
          boxShadow: 'none',
          height: 50,
        },
        outlined: {
          padding: 5,
          fontSize: 10,
          textTransform: 'none',
        },
      },
    },
    MuiInputLabel: {
      styleOverrides: {
        outlined: {
          maxWidth: 'calc(100% - 20px)',
        },
      },
    },
    MuiRadio: {
      styleOverrides: {
        root: {
          color: PRIMARY_BLUE,
        },
        colorSecondary: {
          color: PRIMARY_BLUE,
          '&$checked': {
            color: PRIMARY_BLUE,
          },
        },
      },
    },
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          borderRadius: 0,
        },
      },
    },
    MuiLink: {
      styleOverrides: {
        root: {
          color: PRIMARY_BLUE,
        },
      },
    },
    MuiCssBaseline: {
      styleOverrides: `
        @font-face {
          font-family: 'Apercu';
          font-style: normal;
          font-weight: 100;
          src: url(${ApercuAktivThin}) format("woff2");
        }
        @font-face {
          font-family: 'Apercu';
          font-style: normal;
          font-weight: 200;
          src: url(${ApercuAktivExtraLight}) format("woff2");
        }
        @font-face {
          font-family: 'Apercu';
          font-style: normal;
          font-weight: 300;
          src: url(${ApercuAktivLight}) format("woff2");
        }
        @font-face {
          font-family: 'Apercu';
          font-style: normal;
          font-weight: 400;
          src: url(${ApercuAktivRegular}) format("woff2");
        }
        @font-face {
          font-family: 'Apercu';
          font-style: normal;
          font-weight: 500;
          src: url(${ApercuAktivMedium}) format("woff2");
        }
        @font-face {
          font-family: 'Apercu';
          font-style: normal;
          font-weight: 700;
          src: url(${ApercuAktivBold}) format("woff2");
        }
        @font-face {
          font-family: 'Apercu';
          font-style: normal;
          font-weight: 900;
          src: url(${ApercuAktivBlack}) format("woff2");
        }
        body {
          overflow: hidden;
        }
        `,
    },
    MuiTabs: {
      styleOverrides: {
        root: {
          '& > div > span': {
            height: 3,
          },
        },
      },
    },
  },
};
const NeoTheme = createTheme(NeoBaseTheme);

export default NeoTheme;
